// components/ModuleGate.js
// Route-level companion to Sidebar.js's nav_modules gating (14 Aug 2026). Hiding the
// sidebar item isn't enough on its own — this stops someone with an old bookmark or a
// typed-in URL from landing on a page whose module the company has switched off. The
// API already 403s the underlying data calls either way; this just gives a clean
// redirect instead of a broken/error-y page.
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const token = () => localStorage.getItem('token');

export default function ModuleGate({ module, children }) {
  const [status, setStatus] = useState('loading'); // loading | allowed | blocked

  useEffect(() => {
    let cancelled = false;
    fetch('/api/company-profile/nav-modules', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : { nav_modules: {} })
      .then(d => {
        if (cancelled) return;
        setStatus(d.nav_modules?.[module] === false ? 'blocked' : 'allowed');
      })
      // Fail open on a network error — the API route itself still enforces the real
      // block, this is just UX, so don't strand someone on a blank screen offline.
      .catch(() => { if (!cancelled) setStatus('allowed'); });
    return () => { cancelled = true; };
  }, [module]);

  if (status === 'loading') return null;
  if (status === 'blocked') return <Navigate to="/dashboard" replace />;
  return children;
}
